import SectionHeading from "./SectionHeading";

const steps = [
  { n: "01", title: "Explore", text: "Start from a problem we keep hitting in our own work." },
  { n: "02", title: "Prototype", text: "Build the smallest version that tests the idea." },
  { n: "03", title: "Use it ourselves", text: "Run it on real work until it holds up." },
  { n: "04", title: "Ship", text: "Release it when it is ready for other teams." },
];

const HowSection = () => (
  <section
    id="process"
    className="mx-auto max-w-[1200px] scroll-mt-[68px] px-[clamp(16px,5vw,48px)] pt-[clamp(80px,10vw,140px)]"
  >
    <SectionHeading index="03" label="Process">
      How we build
    </SectionHeading>
    <ol className="mt-14 grid list-none grid-cols-[repeat(auto-fit,minmax(min(100%,230px),1fr))] gap-x-6 gap-y-10 p-0">
      {steps.map((s) => (
        <li key={s.n} className="relative border-t border-border pt-7">
          <span className="absolute -top-[5px] left-0 h-[9px] w-[9px] rotate-45 bg-grad-primary" aria-hidden="true" />
          <div className="font-mono text-[clamp(36px,4vw,52px)] leading-none tracking-[-0.04em] text-accent-text">
            {s.n}
          </div>
          <h3 className="mt-6 text-[23px] font-semibold tracking-[-0.02em]">{s.title}</h3>
          <p className="text-pretty mt-2 text-base leading-[1.6] text-muted-foreground">{s.text}</p>
        </li>
      ))}
    </ol>
  </section>
);

export default HowSection;
